import React, { useState } from "react";
import { ArrowUpRight } from "@phosphor-icons/react";
import { REFERENCES } from "./assets";

const filters = [
  { id: "mind", label: "Mind" },
  { id: "kicsi", label: "Kisebb" },
  { id: "kozepes", label: "Középméretű" },
  { id: "nagy", label: "Nagy" },
];

export default function References() {
  const [active, setActive] = useState("mind");
  const visible = active === "mind" ? REFERENCES : REFERENCES.filter((p) => p.category === active);

  return (
    <section id="references" data-testid="references-section" className="py-20 md:py-32 bg-[#FFFFFF] border-y border-[#E4E4E7]">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
          <div className="max-w-2xl">
            <span className="badge-chip" style={{ background: "#0F0F0F", color: "#FFFFFF" }}>
              Ügyfeleink építkezései
            </span>
            <h2 className="font-display font-black text-4xl md:text-5xl lg:text-6xl tracking-tight mt-4 leading-[0.95]">
              Valódi projektek,<br/>valódi határidőkkel.
            </h2>
          </div>
          <div className="flex flex-wrap gap-2">
            {filters.map((f) => (
              <button
                key={f.id}
                data-testid={`filter-${f.id}`}
                onClick={() => setActive(f.id)}
                className={`px-4 py-2 text-sm font-semibold border transition-all ${
                  active === f.id
                    ? "bg-[#0F0F0F] text-[#FFFFFF] border-[#0F0F0F]"
                    : "bg-white text-[#0F0F0F] border-[#E4E4E7] hover:border-[#0F0F0F]"
                }`}
              >
                {f.label}
              </button>
            ))}
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-px bg-[#E4E4E7] border border-[#E4E4E7]">
          {visible.map((p, i) => (
            <article key={i} data-testid={`reference-card-${i}`} className="bg-white group cursor-pointer">
              <div className="relative aspect-[4/3] overflow-hidden bg-[#F5F5F5]">
                <img
                  src={p.img}
                  alt={p.title}
                  loading="lazy"
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute top-3 right-3 opacity-0 group-hover:opacity-100 transition-opacity">
                  <div className="w-9 h-9 bg-[#FFFFFF] flex items-center justify-center rounded-sm">
                    <ArrowUpRight size={18} weight="bold" className="text-[#0F0F0F]" />
                  </div>
                </div>
              </div>
              <div className="p-5">
                <div className="font-display font-bold text-lg tracking-tight mb-1">{p.title}</div>
                <div className="text-xs text-[#525252] uppercase tracking-wider mb-2">{p.location}</div>
                <div className="text-sm text-[#0F0F0F]">{p.meta}</div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
